import React from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import styles from '@/views/components/BackButton/BackButton.module.scss';
import { toUnitless } from '@mui/material/styles/cssUtils';

const BackButton = ({url=null, title=dict.back}) => {
	const { dict } = useSelector((state) => state.app);
	const navigate = useNavigate();
	return (
		<div className={ styles['button__back'] }
			onClick={ () => {
				if (url){
					navigate(url);
				}else{
					navigate(-1);
				}    
			} }
		>
			<div className={ `icon-arrow-left-full ${ styles['icon'] }` } />
			{title}
		</div>
	);
};

export default BackButton;